import { FrequencyType, Pager, ChannelType, RenewalType, SubscriptionStatus } from 'src/app/core';

export interface GetSubscriptionsParams {
  phoneNumber?: string; // oneof identifier
  lineId?: string; // oneof identifier
  groupId?: string; // oneof identifier
  subscriptionId?: string; // oneof identifier
  subscriptionStatus: SubscriptionStatus[];
  channels?: ChannelType[];
  renewalTypes?: RenewalType[];
  subscriptionFrequencies?: FrequencyType[];
  includeAttachments?: boolean;
  pager?: Pager;
};
